import { useEffect, useRef } from 'react';

/** Plays one video track. Always muted: audio is played by separate elements. */
export function VideoView({ track, mirrored = false, contain = false }: { track: MediaStreamTrack; mirrored?: boolean; contain?: boolean }) {
  const ref = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.srcObject = new MediaStream([track]);
    // Autoplay can be refused until the person interacts; joining is an interaction.
    el.play().catch(() => {});
    return () => {
      el.srcObject = null;
    };
  }, [track]);
  return <video ref={ref} autoPlay playsInline muted style={{ transform: mirrored ? 'scaleX(-1)' : 'none', objectFit: contain ? 'contain' : 'cover' }} />;
}
